import commonCss from './common.css?inline'
import fullTemplate from './full/template.html?raw'
import accordionTemplate from './accordion/template.html?raw'
import type { WidgetV2AdvancedSearchVariant } from '../../layout-variants'

export function getAdvancedSearchTemplate(variant: WidgetV2AdvancedSearchVariant): string {
  if (variant === 'accordion') return accordionTemplate
  return fullTemplate
}

export function getAdvancedSearchCss(): string {
  return commonCss
}
